import { Box } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import Spinner from '../Spinner';
import BannerForm from './BannerForm';

const BannersDetailsForm = ({ banner, onBack, onSuccess, onCopy, del }) => {
  const fetch = useFetch();

  const [segments, setSegments] = useState();
  const [userError, setUserError] = useState();
  const [loadError, setLoadError] = useState();
  const { accountId, domainId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/segments?scope=internal`)
      .then(({ segments }) => {
        setSegments(segments);
      })
      .catch(setLoadError);
  }, [fetch, accountId, domainId]);

  const update = (banner) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/banners/${banner.id}`, {
      method: 'PUT',
      body: JSON.stringify(banner),
    })
      .then(({ banner }) => onSuccess(banner))
      .catch(setUserError);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (banner === undefined || segments === undefined) {
    return <Spinner />;
  }

  return (
    <>
      <BannerForm
        type={banner.type}
        banner={banner}
        segments={segments}
        saveBanner={(banner) => {
          update(banner);
        }}
        deleteBanner={del}
        cancel={onBack}
        copyBanner={onCopy}
      />
      {userError ? (
        <Box ta="right">
          <ErrorMessage message={userError.message} />
        </Box>
      ) : null}
    </>
  );
};

export default BannersDetailsForm;
